import { memo } from 'react';

import { PrivateWorkspaceAgentBoardListQuery } from '~/components/v2/components/workspace/workspace-agent-panel/mentions/PrivateWorkspaceAgentBoardListQuery';
import {
  type WorkspaceAgentBoardListQuerySpec,
  type WorkspaceAgentBoardListSnapshotHandler,
} from '~/components/v2/components/workspace/workspace-agent-panel/mentions/workspaceAgentBoardListQuery';

export type PrivateWorkspaceAgentSelectAssetBoardListQueriesProps = {
  onSnapshot: WorkspaceAgentBoardListSnapshotHandler;
  specs: readonly WorkspaceAgentBoardListQuerySpec[];
};

export const PrivateWorkspaceAgentSelectAssetBoardListQueries = memo(
  ({ onSnapshot, specs }: PrivateWorkspaceAgentSelectAssetBoardListQueriesProps) => (
    <>
      {specs.map((spec) => (
        <PrivateWorkspaceAgentBoardListQuery enabled key={spec.nodeId} onSnapshot={onSnapshot} spec={spec} />
      ))}
    </>
  ),
);

PrivateWorkspaceAgentSelectAssetBoardListQueries.displayName = 'PrivateWorkspaceAgentSelectAssetBoardListQueries';
